import { useStore } from "jotai";
import { memo, useEffect, useRef } from "react";
import type { UID } from "#scripts/vmc/WorldState.ts";
import { getUIDColor } from "./getUIDColor.tsx";
import { devHoverDetailsAtom } from "./useDevHover.ts";

const getStyleText = (uid: UID) => `
  [data-uid="${uid}"] { 
    outline: var(--uid-outline-width, 1.5px) solid var(--uid-outline-color, ${getUIDColor(uid).container.borderColor}) !important; 
  }
  [data-uid="${uid}"] [data-uid="${uid}"] { 
    outline: none !important; 
  }
`;

export const DevUIDStyles = memo(() => {
  const store = useStore();
  const styleRef = useRef<HTMLStyleElement>();

  useEffect(() => {
    const style = document.createElement("style");
    document.head.appendChild(style);
    styleRef.current = style;
    const unsub = store.sub(devHoverDetailsAtom, () => {
      const details = store.get(devHoverDetailsAtom);
      const style = styleRef.current;
      if (!style) return;

      if (details?.uid && !details.isClick) {
        const styleText = getStyleText(details.uid);
        style.textContent = styleText;
      } else {
        style.textContent = "";
      }
    });
    return () => {
      style.remove();
      unsub();
    };
  }, [store]);

  return null;
});
DevUIDStyles.displayName = "DevUIDStyles";
